import { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { MARKETING_HOME_URL } from '../constants/externalLinks';
import { clearSessionMarker } from '../utils/sessionMarker';

/** Encerra a sessão no app e volta ao site institucional. */
const LogoutRedirect: React.FC = () => {
  const { logout, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    const run = async () => {
      clearSessionMarker();
      try {
        await logout();
      } catch (error) {
        console.error('Erro ao sair:', error);
      }
      window.location.replace(MARKETING_HOME_URL);
    };

    void run();
  }, [isLoading, logout]);

  return (
    <div className="flex h-screen items-center justify-center text-gray-600">
      Saindo...
    </div>
  );
};

export default LogoutRedirect;
